<nav class="navbar navbar-expand-xl" [ngClass]="{
  'confondo': navbarBackground,
  'parado': !showNavbar
}">
    <div class="container-fluid">
        <!-- Logo -->
        <a class="navbar-brand d-flex align-items-center justify-content-center"
            [routerLink]="routeHelper.buildRoute('')">
            <img src="/logo-iki.svg" alt="Logo" class="logo-light">
            <img src="/logo-iki-blau.svg" alt="Logo" class="logo-dark">
        </a>

        <!-- Botón toggler para móvil -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Contenido del navbar -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent" #navMenuEl>
            <!-- Menú principal -->
            <ul class="navbar-nav d-flex justify-content-around">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('')" [class.active]="isActiveRoute('')">
                        {{ 'navbar.home' | translate }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('for-who')"
                        [class.active]="isActiveRoute('/for-who')">
                        {{ 'navbar.for_who' | translate }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('community')"
                        [class.active]="isActiveRoute('/community')">
                        {{ 'navbar.community' | translate }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('professionals')"
                        [class.active]="isActiveRoute('/professionals')">
                        {{ 'navbar.coaches' | translate }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('about-us')"
                        [class.active]="isActiveRoute('/about-us')">
                        {{ 'navbar.about' | translate }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="routeHelper.buildRoute('insights')"
                        [class.active]="isActiveRoute('/insights')">
                        {{ 'navbar.insights' | translate }}
                    </a>
                </li>
            </ul>

            <!-- Acciones del navbar (área privada + selector de idioma) -->
            <div class="navbar-actions">
                <!-- Área privada -->
                <a class="private-area-button" href="https://gestor.iki.health" target="_blank">
                    <svg class="private-area-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <span class="private-area-text">{{ 'navbar.private_area' | translate }}</span>
                </a>

                <!-- Selector de idioma -->
                <div class="language-dropdown">
                    <div class="language-selector" (click)="toggleLanguageDropdown()">
                        <span class="language-flag">{{ getCurrentLanguageFlag() }}</span>
                        <span class="language-text">{{ getCurrentLanguageText() }}</span>
                        <span class="dropdown-arrow" [ngClass]="{'open': languageDropdownOpen}">▼</span>
                    </div>
                    <div class="language-options" [ngClass]="{'show': languageDropdownOpen}">
                        <div class="language-option" (click)="changeLanguage('es')"
                            [ngClass]="{'active': currentLanguage === 'es'}">
                            <span class="option-flag">🇪🇸</span>
                            <span class="option-text">{{ 'navbar.spanish' | translate }}</span>
                        </div>
                        <div class="language-option" (click)="changeLanguage('en')"
                            [ngClass]="{'active': currentLanguage === 'en'}">
                            <span class="option-flag">🇺🇸</span>
                            <span class="option-text">{{ 'navbar.english' | translate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>